module.exports = __webpack_public_path__ + "img/四川大学logo.65d0ddfe.png";